/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {callWSFunction} from "../APIClient.jsx";

const Services = function (serviceId) {


    async function create(servicesName, serviceType, nodeId, settings = {}) {
        return callWSFunction("services.create", {
            serviceId: serviceId,
            servicesName: servicesName,
            serviceType: serviceType,
            nodeId: nodeId,
            settings: settings,
        })

    }


    async function remove() {
        return callWSFunction("services.remove", {
            serviceId: serviceId,
        })
    }

    async function getInfo() {

    }

    async function doesExist() {

    }

    function getLogs() {

    }

    function update(values) {

    }


    return {create, remove, getInfo, getLogs, doesExist, update}
}

export {Services}